import { render, staticRenderFns } from "./PCamera.vue?vue&type=template&id=1e92606a&"
import script from "./PCamera.vue?vue&type=script&lang=js&"
export * from "./PCamera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports